/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Clear_Deer_ConfirmInputs */

const en_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm the new email address for your account`)
};

const id_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfirmasikan alamat email baru untuk akun Anda`)
};

const ms_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahkan alamat emel baharu untuk akaun anda`)
};

const ca_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirma la nova adreça de correu electrònic per al teu compte.`)
};

const cs_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrďte novou emailovou adresu pro váš účet`)
};

const da_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræft den nye e-mailadresse til din konto`)
};

const de_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen Sie die neue E-Mail-Adresse für Ihr Konto`)
};

const et_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinnitage oma konto uus e-posti aadress`)
};

const es_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirma la nueva dirección de correo electrónico para tu cuenta`)
};

const fr_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmez la nouvelle adresse e-mail`)
};

const hr_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdite novu e-mail adresu za svoj račun.`)
};

const it_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma il nuovo indirizzo email per il tuo account`)
};

const lv_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apstipriniet jauno e-pasta adresi savam kontam.`)
};

const lt_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patvirtinkite naują el. pašto adresą savo paskyrai`)
};

const hu_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erősítse meg az új email címet a fiókjához`)
};

const nl_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevestig het nieuwe e-mailadres voor je account`)
};

const nb_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekreft den nye e-postadressen`)
};

const pl_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdź nowy adres e-mail dla swojego konta`)
};

const pt_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirme o novo endereço de e-mail para sua conta.`)
};

const ro_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmați noua adresă de e-mail pentru contul dvs.`)
};

const sk_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrďte novú e-mailovú adresu vášho účtu`)
};

const sl_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrdite nov e-poštni naslov za vaš račun`)
};

const fi_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvista uusi sähköpostiosoite tilillesi.`)
};

const sv_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekräfta den nya e-postadressen för ditt konto`)
};

const vi_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận địa chỉ email mới cho tài khoản của bạn`)
};

const tr_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabınız için yeni e-posta adresini onaylayın`)
};

const el_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιβεβαιώστε τη νέα διεύθυνση email για τον λογαριασμό σας`)
};

const bg_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Потвърдете новия имейл адрес за вашия акаунт.`)
};

const ru_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердите новый адрес электронной почты для вашего аккаунта.`)
};

const sr_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Потврдите нову имејл адресу за ваш налог`)
};

const uk_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтвердіть нову адресу електронної пошти для вашого облікового запису`)
};

const ka_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დაადასტურეთ ახალი მეილის მისამართი თქვენი ანგარიშისთვის.`)
};

const hi_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने खाते के लिए नया ईमेल पता पुष्टि करें`)
};

const th_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันที่อยู่อีเมลใหม่สำหรับบัญชีของคุณ`)
};

const ko_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 이메일 주소를 확인하세요`)
};

const zh_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请确认您账户的新电子邮件地址`)
};

const zh_tw_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請確認您帳戶的新電子郵件地址`)
};

const ja_bright_clear_deer_confirm = /** @type {(inputs: Bright_Clear_Deer_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントの新しいメールアドレスを確認してください`)
};

/**
* | output |
* | --- |
* | "Confirm the new email address for your account" |
*
* @param {Bright_Clear_Deer_ConfirmInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const bright_clear_deer_confirm = /** @type {((inputs?: Bright_Clear_Deer_ConfirmInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Clear_Deer_ConfirmInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bright_clear_deer_confirm(inputs)
	if (locale === "ms") return ms_bright_clear_deer_confirm(inputs)
	if (locale === "ca") return ca_bright_clear_deer_confirm(inputs)
	if (locale === "cs") return cs_bright_clear_deer_confirm(inputs)
	if (locale === "da") return da_bright_clear_deer_confirm(inputs)
	if (locale === "de") return de_bright_clear_deer_confirm(inputs)
	if (locale === "et") return et_bright_clear_deer_confirm(inputs)
	if (locale === "es") return es_bright_clear_deer_confirm(inputs)
	if (locale === "fr") return fr_bright_clear_deer_confirm(inputs)
	if (locale === "hr") return hr_bright_clear_deer_confirm(inputs)
	if (locale === "it") return it_bright_clear_deer_confirm(inputs)
	if (locale === "lv") return lv_bright_clear_deer_confirm(inputs)
	if (locale === "lt") return lt_bright_clear_deer_confirm(inputs)
	if (locale === "hu") return hu_bright_clear_deer_confirm(inputs)
	if (locale === "nl") return nl_bright_clear_deer_confirm(inputs)
	if (locale === "nb") return nb_bright_clear_deer_confirm(inputs)
	if (locale === "pl") return pl_bright_clear_deer_confirm(inputs)
	if (locale === "pt") return pt_bright_clear_deer_confirm(inputs)
	if (locale === "ro") return ro_bright_clear_deer_confirm(inputs)
	if (locale === "sk") return sk_bright_clear_deer_confirm(inputs)
	if (locale === "sl") return sl_bright_clear_deer_confirm(inputs)
	if (locale === "fi") return fi_bright_clear_deer_confirm(inputs)
	if (locale === "sv") return sv_bright_clear_deer_confirm(inputs)
	if (locale === "vi") return vi_bright_clear_deer_confirm(inputs)
	if (locale === "tr") return tr_bright_clear_deer_confirm(inputs)
	if (locale === "el") return el_bright_clear_deer_confirm(inputs)
	if (locale === "bg") return bg_bright_clear_deer_confirm(inputs)
	if (locale === "ru") return ru_bright_clear_deer_confirm(inputs)
	if (locale === "sr") return sr_bright_clear_deer_confirm(inputs)
	if (locale === "uk") return uk_bright_clear_deer_confirm(inputs)
	if (locale === "ka") return ka_bright_clear_deer_confirm(inputs)
	if (locale === "hi") return hi_bright_clear_deer_confirm(inputs)
	if (locale === "th") return th_bright_clear_deer_confirm(inputs)
	if (locale === "ko") return ko_bright_clear_deer_confirm(inputs)
	if (locale === "zh") return zh_bright_clear_deer_confirm(inputs)
	if (locale === "zh-tw") return zh_tw_bright_clear_deer_confirm(inputs)
	if (locale === "ja") return ja_bright_clear_deer_confirm(inputs)
	return en_bright_clear_deer_confirm(inputs)
});